import React from 'react';
import { Route } from 'react-router-dom';
import AsyncLoader from 'base/navigator/AsyncLoader';
import notFound from '../views/m_404/index';

const getMRoutes = function () {
  return (
    [
      <Route
        path="/mfbs/mstd/recommendedmatch"
        component={AsyncLoader(() => import('../views/recommendedmatch/index'), 'RecommendedMatch')}
      />,
      <Route
        path="/mfbs/mstd/product"
        component={AsyncLoader(() => import('../views/product/index'), 'Detail')}
      />,
      <Route
        path="/commodity/detail/:_pid"
        component={AsyncLoader(() => import('../views/product/index'), 'Detail')}
      />,
      <Route
        path="/mfbs/mstd/product_3d_show"
        component={AsyncLoader(() => import('../views/product3dShow/index'), 'Product3dShow')}
      />,
      <Route
        path="/intelligentMatch"
        component={AsyncLoader(() => import('../views/intelligentMatch/index'), 'IntelligentMatch')}
      />,
      <Route
        path="/mfbs/mstd/pano"
        component={AsyncLoader(() => import('../views/pano/index'), 'Pano')}
      />,
      <Route
        path="/newaddress"
        component={AsyncLoader(() => import('../views/address/AddressDetail'), 'NewAddress')}
      />,
      <Route
        path="/mfbs/mstd/newaddress"
        component={AsyncLoader(() => import('../views/address/AddressDetail'), 'NewAddress')}
      />,
      <Route
        path="/editaddress"
        component={AsyncLoader(() => import('../views/address/AddressDetail'), 'EditAddress')}
      />,
      <Route
        path="/mfbs/mstd/editaddress"
        component={AsyncLoader(() => import('../views/address/AddressDetail'), 'EditAddress')}
      />,
      <Route
        path="/cart"
        component={AsyncLoader(() => import('../views/cart/index'), 'cart')}
      />,
      <Route
        path="/mfbs/mstd/cart"
        component={AsyncLoader(() => import('../views/cart/index'), 'cart')}
      />,
      <Route
        path="/mfbs/mstd/joinmore"
        component={AsyncLoader(() => import('../views/joinmore/index'), 'FullPakage')}
      />,
      <Route
        path="/mfbs/mstd/shop/joinmore"
        component={AsyncLoader(() => import('../views/joinmore/index'), 'FullPakage')}
      />,
      <Route
        path="/mfbs/mstd/tr/joinmore"
        component={AsyncLoader(() => import('../views/joinmore/index'), 'FullPakage')}
      />,
<Route component={notFound} />
    ]
  );
};
export default getMRoutes;
